import { render } from "./MessageBox.vue?vue&type=template&id=6ef5abf3&ts=true"
import script from "./message-box-component.ts?vue&type=script&lang=ts&external"
export * from "./message-box-component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__